/*
* Copyright (C) Regione Lombardia
*/
import { Injectable } from '@angular/core';
import { NgbDateAdapter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class DatepickerAdapter extends NgbDateAdapter<Date> {

    readonly DELIMITER = '/';

    fromModel(value: Date | null): NgbDateStruct | null {
        if (value) {
            value = new Date(value);
            return {
                day: parseInt(value.getDate().toFixed(0), 10),
                month: parseInt(value.getMonth().toFixed(0), 10) + 1,
                year: parseInt(value.getFullYear().toFixed(0), 10)
            };
        }
        return null;
    }

    toModel(date: NgbDateStruct | null): Date | null {
        if (date) {
            const newDate: string = [
                ('0' + date.month).slice(-2),
                ('0' + date.day).slice(-2),
                date.year
            ].join(this.DELIMITER)
            return new Date(newDate);
        }
        return null;
    }

}
